// SYNC: duplicated verbatim across cres-t1/t11/t5/t6 (separate frontend apps, no shared package) —
// keep the copies in sync. The assistant backend is centralized in cres-aws-t2.
// Client helper for the ParkourAI in-app assistant. The assistant backend is CENTRALIZED in the
// Developer (t2) app — there is no per-app assistant Lambda. We call t2/v1/assistant cross-app via
// AxiosDeveloperAPI (t2's authorizer accepts our token; the platform DB is shared), so the assistant
// can answer both this app's questions and cross-app (e.g. Developer exception) questions.
//   POST {Message, Messages} -> {Reply, Messages, Activity, Model}
// The conversation is stateless server-side: the raw `messages` array is opaque (Anthropic/Bedrock
// message blocks) and is round-tripped back each turn to preserve context. The final Reply and the
// per-tool Activity steps both come back on this HTTP response (the source of truth).
import { makeCresAxios } from "../util/CresAxios";

/** One tool step the assistant took this turn (for optional display). */
export type AssistantActivity = {
    kind: string;
    text: string;
};

export type AssistantTurn = {
    /** The assistant's final text reply for this turn. */
    reply: string;
    /** Updated raw message history — pass this straight back on the next turn. */
    messages: any[];
    /** Tool steps taken this turn. */
    activity: AssistantActivity[];
    /** Friendly name of the model that answered (may differ from the default after a fallback). */
    model: string | null;
};

/** Send one user message and get the assistant's reply plus the updated history. */
export async function sendAssistantMessage(sessionContext: any, message: string,
                                           priorMessages: any[]): Promise<AssistantTurn> {
    const res = await makeCresAxios(sessionContext)({
        method: "POST",
        url: "t11/v1/assistant",
        data: {Message: message, Messages: priorMessages},
    });
    const body = res?.data ?? {};
    return {
        reply: String(body.Reply ?? ""),
        messages: Array.isArray(body.Messages) ? body.Messages : priorMessages,
        activity: Array.isArray(body.Activity) ? body.Activity : [],
        model: body.Model ? String(body.Model) : null,
    };
}
